import Footer from 'Components/Home/Footer';
import Navbar from 'Components/Home/Navbar';
import MainHeadingSub from 'Components/MainHeading/MainHeadingSub';

import Summary from 'Components/Summary/Summary';
import Team from 'Components/Team/Team';
import Values from 'Components/VisionCoreValues/Values';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import aboutUsImg from 'Assets/elvotaimages/Heading/contactUsImg.jpg';
import FooterTop from 'Components/FooterTop/FooterTop';

export default function AboutUs() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      return;
    }

    const targetId = location.hash.replace('#', '');
    const target = document.getElementById(targetId);

    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [location.hash]);

  const content = [
    'Evolta Technologies is a tech-enabled energy trading firm specializing in battery optimization in the Texas market.By combining our disciplined market execution with structured intelligence, we drive energy market efficiency and support growing energy demand.',
    'Founded in Switzerland, our team of experienced experts shares a singular mission: to accelerate the energy transition through innovative technology and profitability.',
    'Managing energy effectively is critical today and it will be even more vital tomorrow. At Evolta Technologies, we turn this challenge into opportunity, helping unlock the full potential of energy storage and shape a cleaner, more sustainable future.',
  ];
  return (
    <div>
      <Navbar />
      <MainHeadingSub
        simple="About Us "
        highlighted=""
        imageSrc={`linear-gradient(0deg, rgba(17, 64, 54, 0.3), rgba(17, 64, 54, 0.3)), url(${aboutUsImg})`}
      />
      <div className="main-container">
        <Summary paragraph={content} />
      </div>
      <div className="additional-bg" id="team">
        <div className="main-container">
          <Team />
        </div>
      </div>
      <div
        className="main-container lg:pb-[250px] pb-[150px]"
        id="vision-core-values"
      >
        <Values />
      </div>
      <FooterTop />
      <Footer />
    </div>
  );
}
